import BanqueDetailController from './banque.detail.controller';

export default {
    template: require('./banque.detail.html'),
    controller: BanqueDetailController
};
